import React, { Fragment } from "react";
import NotaEstudiante from "../ejercicios/Alternativos/NotaEstudiante";
import RaicesReales from "../ejercicios/Alternativos/RaicesReales";
import AlquilerAuto from "../ejercicios/Alternativos/AlquilerAuto";
import SumaBinarios from "../ejercicios/Alternativos/SumaBinarios";

const Alternativos = () => {
  return (
    <Fragment>
      <NotaEstudiante />
      <RaicesReales />
      <AlquilerAuto />
      <SumaBinarios />
    </Fragment>
  );
};

export default Alternativos;
